var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerportalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7071 12.5C17.0976 12.8905 17.0976 13.5237 16.7071 13.9142L14.2071 16.4142C13.832 16.7893 13.3233 17 12.7929 17H5.12132L4.41421 17.7071C4.21895 17.9024 3.96303 18 3.70711 18H0V16.2929L3.41421 12.8787C3.97682 12.3161 4.73988 12 5.53553 12H11.2071C11.2071 13.1046 10.3117 14 9.20711 14H8.70711C8.43096 14 8.20711 14.2239 8.20711 14.5C8.20711 14.7761 8.43096 15 8.7071 15H11.9645C12.4949 15 13.0036 14.7893 13.3787 14.4142L15.2929 12.5C15.6834 12.1095 16.3166 12.1095 16.7071 12.5Z",
    fill: "#526069"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.96356,
    cy: 5,
    r: 2,
    stroke: "#526069",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63721 10C5.4055 8.81753 7.05396 8 8.96358 8C10.8732 8 12.5217 8.81753 13.2899 10",
    stroke: "#526069",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerportalLogo);
export default __webpack_public_path__ + "static/media/customerportal-logo.e717002d8d883b9f0fa24ee66a6cb9a4.svg";
export { ForwardRef as ReactComponent };